export const MODAL_TRANSITION_DURATION_MS_DEFAULT = 300;

export const MODAL_STEP_CHECK_SHORTLIST = 'checkShortlist';
export const MODAL_STEP_CHECK_SHORTLIST_RESULT = 'checkShortlistResult';
export const MODAL_STEP_PROMOTION_DETAILS = 'promotionDetails';
export const MODAL_STEP_REPORT_ERROR = 'reportError';
export const MODAL_STEP_SHARE_VIA_EMAIL = 'shareViaEmail';
export const MODAL_STEP_PROCESS_RESULT = 'processResult';

export const CACHE_KEY_NEWCAR_PROMOTION_DATA = (
  'new_car_promo_data'
);
export const CACHE_TTL_NEWCAR_PROMOTION_DATA = 1200;

export const PROCESS_RESULT_TITLE_SHARE_VIA_EMAIL_SUCCESS = 'Email Sent!';
export const PROCESS_RESULT_TITLE_SHARE_VIA_EMAIL_FAIL = 'Error Occurred';

export const PROCESS_RESULT_MESSAGE_SHARE_VIA_EMAIL_SUCCESS = 'Thank you.';
export const PROCESS_RESULT_MESSAGE_SHARE_VIA_EMAIL_FAIL = '';

export const PROCESS_RESULT_TITLE_REPORT_ERROR_SUCCESS = 'Submission Sent!';
export const PROCESS_RESULT_TITLE_REPORT_ERROR_FAIL = 'Error Occurred';

export const PROCESS_RESULT_MESSAGE_REPORT_ERROR_SUCCESS = 'Thank you for bringing the error to our attention.\nRest assured, our team will investigate this matter promptly.'; // @suppress longLineCheck
export const PROCESS_RESULT_MESSAGE_REPORT_ERROR_FAIL = '';
